import { useBaseMutation } from "../baseMutation";
import { RestError } from "@maven-rest/common/HttpRequest";
import { ValidateDocumentSignerStampImageRequest, ValidateDocumentSignerStampImageResponse } from "@maven-rest/docs/S3.dto";
import { S3Url } from "@maven-rest/docs/S3.url";

export function useValidateDocumentSignerStampImage(req: {
  onSuccess: (data: ValidateDocumentSignerStampImageResponse, variables: ValidateDocumentSignerStampImageRequest, context: unknown) => void;
  onError: (error: RestError<unknown>, variables: ValidateDocumentSignerStampImageRequest, context: unknown) => void;
}) {
  return useBaseMutation({
    fnOption: {
      url: S3Url.validateDocumentSignerStampImage,
    },
    onSuccess: req.onSuccess,
    onError: req.onError,
  });
}
